import React from 'react';
import { HEIGHT_FOOT } from '../Config';
import Genero from '../graficos/Genero';
import GrupoEdad from '../graficos/GrupoEdad';
import Etnica from '../graficos/Etnica';
import Vulnerables from '../graficos/Vulnerables';
import Fechas from './Fechas';
import { useAppState } from '../graficos/GraficoContext';
import { useEffect } from 'react';

interface FooterProps {
    filtrar: any; // Replace 'any' with the appropriate type for filters
    codigoDivipola: string;
    indicador: any;
}

const FooterDetalles: React.FC<FooterProps> = ({ filtrar, codigoDivipola, indicador }) => {
    const { tieneEtnica, tieneGrupoEdad, tieneVulnerables, tieneGenero } = useAppState();

    useEffect(() => {
        // Aquí puedes agregar cualquier lógica que necesites ejecutar cuando cambien los estados
    }, [tieneEtnica, tieneGrupoEdad, tieneVulnerables, tieneGenero]);
  
    const generoVisibility = tieneGenero ? 'visible' : 'hidden';
    const fila2Visibles = tieneEtnica || tieneGrupoEdad || tieneVulnerables ;
    const fila2Visibility = fila2Visibles ? 'visible' : 'hidden';
    return (
        <footer style={{ height: "auto", backgroundColor: "#ffffff", borderTop: '1px solid #ccc' }}>
            <div style={{ visibility: generoVisibility }}>
                <Genero filtrar={filtrar} codigoDivipola={codigoDivipola} indicador={indicador} />
            </div>
            <div style={{ visibility: fila2Visibility }}>
                <GrupoEdad filtrar={filtrar} codigoDivipola={codigoDivipola} indicador={indicador} />
                <Etnica filtrar={filtrar} codigoDivipola={codigoDivipola} indicador={indicador} />
                <Vulnerables filtrar={filtrar} codigoDivipola={codigoDivipola} indicador={indicador} />
            </div>
            <Fechas filtrar={filtrar} codigoDivipola={codigoDivipola} />
        </footer>
    );
};

export default FooterDetalles;